import { StyleSheet } from 'react-native';

import { Theme } from '@constants';

export const styles = StyleSheet.create({
  sunIcon: {
    height: Theme.px(24),
    width: Theme.px(24),
  },
  sunrise: {
    marginLeft: Theme.px(30),
    marginRight: Theme.px(18),
  },
  sunriseLabel: {
    paddingTop: Theme.px(4),
  },
  sunset: {
    marginLeft: Theme.px(48),
    marginRight: Theme.px(18),
  },
  sunsetLabel: {
    paddingTop: Theme.px(4),
  },
  timeText: {
    marginLeft: Theme.px(18),
  },
});
